import { useState } from "react";
import Nav from "../components/Nav";
import Logo from "../assets/logo-light.svg";
import Cd from "../assets/cd.svg";
import RightArrow from "../assets/rightArrow.svg";
import { Link } from "react-router-dom";
import "./Contact.scss";
const Contact = () => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  return (
    <section id="ContactPage">
      <div className="heading">
        <Nav />
        <Link to="/">
          <img className="Logo" src={Logo} alt="Eleven-a Logo" />
        </Link>
      </div>
      <div className="contactContainer">
        <img className="swirls" src={Cd} alt="Cd Spiral" />
        <h1>contact</h1>
        <section className="formContainer">
          <div className="formItems">
            <h2>contact form</h2>
            <p>Eleven-a does not accept unsolicited submissions of material.</p>
            <form onSubmit={handleSubmit}>
              <div className="input-field">
                <input
                  type="text"
                  id="firstName"
                  value={firstName}
                  onChange={({ target: { value } }) => setFirstName(value)}
                  required
                />
                <label htmlFor="firstName">first name</label>
              </div>
              <div className="input-field">
                <input
                  type="text"
                  id="lastName"
                  value={lastName}
                  onChange={({ target: { value } }) => setLastName(value)}
                  required
                />
                <label htmlFor="lastName">last name</label>
              </div>
              <div className="input-field">
                <input
                  type="text"
                  id="email"
                  value={email}
                  onChange={({ target: { value } }) => setEmail(value)}
                  required
                />
                <label htmlFor="email">email</label>
              </div>
              <div className="input-field">
                <input
                  type="text"
                  id="subject"
                  value={subject}
                  onChange={({ target: { value } }) => setSubject(value)}
                  required
                />
                <label htmlFor="subject">subject</label>
              </div>
              <div className="input-field">
                {/* <input type="text" id="message" required /> */}
                <textarea
                  type="text"
                  id="message"
                  value={message}
                  onChange={({ target: { value } }) => setMessage(value)}
                  rows={5}
                  required
                />
                <label htmlFor="message">message</label>
              </div>
            </form>
            <div className="sendContainer">
              <img className="rightArrow" src={RightArrow} alt="right Arrow" />
              <button onClick={() => console.log("Clicked")}>send</button>
            </div>
          </div>
        </section>
        <footer>
          <ul>
            <li>Eleven-A</li>
            <li>
              <span className="square">■</span> 1920 McKinney Ave, Floor 7
            </li>
            <li>
              <span className="square">■</span> Dallas, TX 75201
            </li>
          </ul>
        </footer>
      </div>
    </section>
  );
};

export default Contact;
